import React from 'react';
import {Button, Card, DatePicker, Form, Icon, Input, message, Modal, Timeline,TimePicker} from 'antd';
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {patchEventAgendas} from "../../services/evt";

import moment from 'moment';


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewAgendaForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    resetFormFields = () => {
        this.props.form.resetFields();
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;

                //去除_开头的属性(为了动态字段添加的)
                var _values = {...values};
                Object.keys(_values).forEach((key) => {
                    if (key != "__self__" && key.startsWith("_")) {
                        delete _values[key]
                    }
                })

                //处理流程的开始结束时间
                if (_values.__self__ && _values.__self__.length > 0) {
                    _values.__self__.forEach((element,index) => {
                        element.date = element.date.format("YYYY-MM-DD");
                        element.fromTime = element.fromTime.format("HH:mm:ss");
                        element.toTime = element.toTime.format("HH:mm:ss");
                        element.seq=index;
                        // delete element.time;
                    })
                }

                if (JSON.stringify(_values) === "{}") {
                    _values.__self__ = [];
                }

                patchEventAgendas(Object.assign({eventId: this.props.evt.header.id}, _values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    addField = (fieldName, index) => {
        const {form} = this.props;
        let _fieldVal = form.getFieldValue(`_${fieldName}`);
        _fieldVal = _fieldVal.concat(1);
        const sVal = {};
        sVal[`_${fieldName}`] = _fieldVal;
        form.setFieldsValue(sVal);
    }

    removeField = (fieldName, index) => {
        const {form} = this.props;
        let fieldVal = form.getFieldValue(fieldName);
        let _fieldVal = form.getFieldValue(`_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        const sVal = {};
        sVal[fieldName] = fieldVal;
        sVal[`_${fieldName}`] = _fieldVal;
        form.setFieldsValue(sVal);
    }

    //移动
    moveQuestionsItem = (fieldName,index,type) =>{
        const {setFieldsValue,getFieldsValue} = this.props.form;
        let fieldsValue  = getFieldsValue();
        let columns  = fieldsValue[`_${fieldName}`];
        let columns1  = fieldsValue[fieldName];
        let from =index;
        let to =type == 'up' ? index-1 : index+1;
        // if (from < to) to--;

        columns.splice(to, 0, columns.splice(from, 1)[0]);
        columns1.splice(to, 0, columns1.splice(from, 1)[0]);
        setFieldsValue(fieldsValue);
    }

    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    render() {
        const evt = this.props.evt;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;

        getFieldDecorator('___self__', {initialValue: evt.agenda.map(a=>a)});
        const agendas = getFieldValue('___self__') ? getFieldValue('___self__') : [];


        const agendaComp =
            <Timeline pending={<a href="#" onClick={() => this.addField("__self__")}>增加新的日程</a>}>
                {agendas.map((c, index) => {
                    return (
                        <Timeline.Item dot={<Icon type="clock-circle-o" style={{fontSize: '16px'}}/>} key={`agenda${index}`}>
                            <Card bodyStyle={{padding: "6px 6px 6px 0"}} style={{border: "none"}}>
                                <div className="form-item-agenda-contain">
                                    <div style={{display: "none"}}>
                                        {getFieldDecorator(`__self__[${index}].id`, {
                                            initialValue: c.id,
                                            rules: [{required: false}],
                                        })(
                                            <Input/>
                                        )}
                                    </div>
                                    <div>
                                        <Form.Item help="" style={{display:'inline-block',marginRight:20}}>
                                            {getFieldDecorator(`__self__[${index}].date`, {
                                                initialValue: c.date? moment(c.date, 'YYYY-MM-DD'): null,
                                                rules: [{required: true}],
                                            })(
                                                <DatePicker/>
                                            )}
                                        </Form.Item>

                                        <Form.Item help="" style={{display:'inline-block'}}>
                                            {getFieldDecorator(`__self__[${index}].fromTime`, {
                                                initialValue: c.fromTime? moment(c.fromTime, 'HH:mm') : null,
                                                rules: [{required: true}],
                                            })(
                                                <TimePicker placeholder="开始时间" format={'HH:mm'} />
                                            )}
                                        </Form.Item>
                                        <span style={{display:'inline-block',lineHeight:'28px'}}> ~ </span>
                                        <Form.Item help="" style={{display:'inline-block'}}>
                                            {getFieldDecorator(`__self__[${index}].toTime`, {
                                                initialValue: c.toTime? moment(c.toTime, 'HH:mm') : null,
                                                rules: [{required: true}],
                                            })(
                                                <TimePicker placeholder="结束时间" format={'HH:mm'} />
                                            )}
                                        </Form.Item>
                                    </div>
                                    <Form.Item hasFeedback help="">
                                        {getFieldDecorator(`__self__[${index}].content`, {
                                            initialValue: c.content,
                                            rules: [{required: true},{whitespace:true, message: '不能输入空格!'},{min: 2, max: 500, message: '长度限制为2至500个之间!'}],
                                        })(
                                            <Input.TextArea autosize={{minRows: 2, maxRows: 3}} placeholder="日程内容，如：会议开始，签到入座"/>
                                        )}
                                    </Form.Item>
                                    <a href="#" className="card-ck-contain-remove" onClick={() => this.removeField("__self__", index)}>
                                        <div><Icon type="delete"/>删除</div>
                                    </a>
                                    <div className='card-ck-contain-move'>
                                        <a onClick={()=>this.moveQuestionsItem('__self__',index,'up')} style={{opacity:index==0 && 0}}>上移</a>
                                        <a onClick={()=>this.moveQuestionsItem('__self__',index,'down')} style={{opacity:index==(agendas.length-1) && 0}}>下移</a>
                                    </div>
                                </div>

                            </Card>
                        </Timeline.Item>
                    )
                })}
            </Timeline>

        return (
            <Form>
                <Timeline>
                    {evt.agenda.map((aga, index) => {
                        return (
                            <Timeline.Item dot={<Icon type="clock-circle-o" style={{fontSize: '16px'}}/>} key={`agenda${index}`}>
                                <div style={{fontWeight: "bold", color: "#000000",marginBottom:4}}>{aga.date}</div>
                                <div>{moment(aga.fromTime, 'HH:mm').format("HH:mm")} ~ {moment(aga.toTime, 'HH:mm').format("HH:mm")} <span style={{marginLeft:10}}>{aga.content}</span></div>
                            </Timeline.Item>
                        )
                    })}
                </Timeline>

                <Modal
                    visible={this.props.editable}
                    title="编辑日程"
                    width="880px"
                    afterClose={() => this.resetFormFields()}
                    maskClosable={false}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >
                    {agendaComp}
                </Modal>
            </Form>
        )
    }
}


EvtViewAgendaForm.contextTypes = {}

EvtViewAgendaForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "agendaEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewAgendaForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewAgendaForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewAgendaForm.jsx